import React from 'react';
import { Button } from './Button';
interface SocialLoginButtonProps {
  provider: 'google' | 'facebook' | 'apple';
  onClick: () => void;
}
export function SocialLoginButton({
  provider,
  onClick
}: SocialLoginButtonProps) {
  const icons = {
    google: 'G',
    facebook: 'f',
    apple: ''
  };
  const labels = {
    google: 'Continue with Google',
    facebook: 'Continue with Facebook',
    apple: 'Continue with Apple'
  };
  return <Button variant="secondary" className="w-full justify-start pl-4" onClick={onClick} icon={<span className="font-bold text-xl w-6 text-center" data-id="element-517">
          {icons[provider]}
        </span>} data-id="element-516">
      {labels[provider]}
    </Button>;
}